"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolCategoryEnum = void 0;
var SymbolCategoryEnum;
(function (SymbolCategoryEnum) {
    SymbolCategoryEnum["CommonStock"] = "cs";
    SymbolCategoryEnum["ETF"] = "et";
    SymbolCategoryEnum["CryptoCurrency"] = "ct";
})(SymbolCategoryEnum = exports.SymbolCategoryEnum || (exports.SymbolCategoryEnum = {}));
//# sourceMappingURL=symbol-category-enum.js.map